{
  "Clear search": "Zoekactie wissen"
}
